// extracted by css-extract-rspack-plugin
export default {"Spacer":"Spacer-module__Spacer__Gz7fi"};